import { render, staticRenderFns } from "./ObservationCard.vue?vue&type=template&id=5d910c1e&scoped=true&"
import script from "./ObservationCard.vue?vue&type=script&lang=js&"
export * from "./ObservationCard.vue?vue&type=script&lang=js&"
import style0 from "./ObservationCard.vue?vue&type=style&index=0&id=5d910c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d910c1e",
  null
  
)

export default component.exports